import axios from 'axios';
import type {
  IGetReactivationPricesParams,
  IGetReactivationPricesRequest,
  IGetReactivationPricesResponse,
} from '@/app-package';

const getReactivationPrices = async (params: IGetReactivationPricesParams) => {
  const config: IGetReactivationPricesRequest = {
    url: `/supra/reactivation_prices/${params.userId}`,
    method: 'get',
  };

  const { data } = await axios.request<IGetReactivationPricesResponse>(config);
  return data;
};

export default getReactivationPrices;
